export default __webpack_public_path__ + "static/media/RightArrow.f77f8a48.svg";